import { render, staticRenderFns } from "./table-footer.vue?vue&type=template&id=0e02f16b"
import script from "./table-footer.vue?vue&type=script&lang=js"
export * from "./table-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports